module.exports = __webpack_public_path__ + "assets/select-user.6fbae668.svg";